/**
 * Tour for the main dashboard / sidebar (Driver.js format).
 * Each step: { route?, element?, popover: { title, description, side, align } }
 */
export const buildDashboardTour = (t, accountId) => {
  const base = `/app/accounts/${accountId}`;
  return [
    {
      route: `${base}/dashboard`,
      popover: {
        title: t('TOUR.DASHBOARD.WELCOME.TITLE'),
        description: t('TOUR.DASHBOARD.WELCOME.DESC'),
      },
    },
    {
      route: `${base}/dashboard`,
      element: 'aside',
      popover: {
        title: t('TOUR.DASHBOARD.SIDEBAR.TITLE'),
        description: t('TOUR.DASHBOARD.SIDEBAR.DESC'),
        side: 'right',
        align: 'start',
      },
    },
    {
      route: `${base}/conversations`,
      element: 'a[href$="/conversations"]',
      popover: {
        title: t('TOUR.DASHBOARD.CONVERSATIONS.TITLE'),
        description: t('TOUR.DASHBOARD.CONVERSATIONS.DESC'),
        side: 'right',
      },
    },
    {
      route: `${base}/conversations`,
      element: 'a[href$="/conversations"]',
      popover: {
        title: t('TOUR.DASHBOARD.ALL_CONVERSATIONS.TITLE'),
        description: t('TOUR.DASHBOARD.ALL_CONVERSATIONS.DESC'),
        side: 'right',
      },
    },
    {
      route: `${base}/mentions/conversations`,
      element: 'a[href$="/mentions/conversations"]',
      popover: {
        title: t('TOUR.DASHBOARD.MENTIONS.TITLE'),
        description: t('TOUR.DASHBOARD.MENTIONS.DESC'),
        side: 'right',
      },
    },
    {
      route: `${base}/unattended/conversations`,
      element: 'a[href$="/unattended/conversations"]',
      popover: {
        title: t('TOUR.DASHBOARD.UNATTENDED.TITLE'),
        description: t('TOUR.DASHBOARD.UNATTENDED.DESC'),
        side: 'right',
      },
    },
    {
      route: `${base}/campaigns`,
      element: 'a[href*="/campaigns"]',
      popover: {
        title: t('TOUR.DASHBOARD.CAMPAIGNS.TITLE'),
        description: t('TOUR.DASHBOARD.CAMPAIGNS.DESC'),
        side: 'right',
      },
    },
    {
      route: `${base}/settings/general`,
      element: 'a[href*="/settings"]',
      popover: {
        title: t('TOUR.DASHBOARD.SETTINGS.TITLE'),
        description: t('TOUR.DASHBOARD.SETTINGS.DESC'),
        side: 'right',
      },
    },
    {
      popover: {
        title: t('TOUR.DASHBOARD.DONE.TITLE'),
        description: t('TOUR.DASHBOARD.DONE.DESC'),
      },
    },
  ];
};
